import API from "../constants/api";
import axiosInstance, { axiosException } from "./axios";

/**
 * Get most decreased pillar
 * @returns 
 */
export const getMostDescreasedPillar = async () => {
  try {
    const response = await axiosInstance.get(API.GET_MOST_DECREASED_PILLAR);
    return response.data;
  } catch (e) {
    return axiosException(e);
  }
}

/**
 * Get unread notifications
 * @returns 
 */
export const getUnreadNotification = async (page = 1, limit = 10) => {
  try {
    const response = await axiosInstance.get(`${API.GET_NOTIFICATIONS}?page=${page}&per_page=${limit}&unread_only=true`);
    if (response.data.status === 'success') return response.data.data;
    return [];
  } catch (e) {
    return axiosException(e);
  }
}

/**
 * Mark read a notification
 */
export const markReadNotification = async (id) => {
  try {
    const response = await axiosInstance.put(`${API.GET_NOTIFICATIONS}/${id}`);
    return response.data;
  } catch (e) {
    return axiosException(e);
  }
}